import React from 'react';
import {connect} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import CustomSelect from './CustomSelect';
import countryList from './country.json';
import * as Yup from 'yup';

import * as RestService from '../../services/eisRest';
import Button from '../../components/button/Button';
import * as ActionTypes from '../../store/actions';


const BasicInformationsTab = ({company,onCompanySave,isActive}) => {


    const [t] = useTranslation();
             
    const yesNoOptions = [
        { value: 1, label: 'Yes' },
        { value: 0, label: 'No' }      
    ];
         

    const countryOptions = countryList;

    const save = (url,values) => {
    
       company.address.name = values.name;
       company.address.street = values.street;
       company.address.houseNumber = values.houseNumber;
       company.address.postalCode = values.postalCode;
       company.address.city = values.city;
       company.address.countryIso  = values.countryIso;
       company.address.businessId = values.businessId;
       company.address.taxId = values.taxId;
       company.address.vatNo = values.vatNo;
       company.address.vatPayer = values.vatPayer;
       company.address.description = values.description;
       company.address.commercialRegister = values.commercialRegister;
       company.address.slogan = values.slogan;

       RestService.callAnyApi(url, company)
           .then((data) => {             
                   toast.success('Save succeed!');                     
                   try{
                       if(data.responseMessage==='OK'){
                           onCompanySave(data.responseObject);
                       }
                   
                   }catch(error){
                       console.error();
                   }
                  
           })
           .catch((error) => {               
               toast.error(
                   (error.response &&
                       error.response.data &&
                       error.response.data.message) ||
                       'Failed'
               );
           });
   };

   const formik = useFormik({
       enableReinitialize: true,
       initialValues: {
           name: company.address.name || "",
           street: company.address.street || "",
           houseNumber: company.address.houseNumber || "",
           postalCode: company.address.postalCode || "",
           city: company.address.city || "",
           countryIso: company.address.countryIso || "",
           businessId: company.address.businessId || "",
           taxId: company.address.taxId || "",
           vatNo: company.address.vatNo || "",
           vatPayer: company.address.vatPayer || 0,
           description: company.address.description || "",
           commercialRegister: company.address.commercialRegister || "",
           slogan: company.address.slogan || ""
       },
       validationSchema: Yup.object({
           name: Yup.string()
               .min(5, 'Must be 5 characters or more')
               .required('Required')
       }),
       onSubmit: (values) => {           
           save('/company/saveBasicInformations',values);
       }
   });


    return (
        <div className={`tab-pane ${isActive ? 'active' : ''}`}>
          
            <form onSubmit={formik.handleSubmit}>
               	  <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <label>{t('general.label.name')}</label>
                            <input type="text" class="form-control" placeholder="" {...formik.getFieldProps('name')} />
                        </div>
                    </div>
				  </div>
                  
                  <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <label>{t('general.label.street')}</label>
                                <input type="text" class="form-control" placeholder=""  {...formik.getFieldProps('street')} />
                            </div>
                        </div>
                  
                        <div class="col-3">
                            <div class="form-group">
                                <label>{t('general.label.houseNumber')}</label>
                                <input type="text" class="form-control" placeholder=""  {...formik.getFieldProps('houseNumber')} />
                            </div>
                        </div>
                 
                        <div class="col-3">
                            <div class="form-group">
                                <label>{t('general.label.postalCode')}</label>
                                <input type="text" class="form-control" placeholder=""  {...formik.getFieldProps('postalCode')}/>
                            </div>
                        </div>
                  </div>
                  
                  <div class="row">
                        <div class="col-3">
                            <div class="form-group">
                                <label>{t('general.label.city')}</label>
                                <input type="text" class="form-control" placeholder=""  {...formik.getFieldProps('city')} />
                            </div>
                        </div>
                 
            
                        <div class="col-3">
                            <div class="form-group">
                                <label>{t('general.label.country')}</label>                               
                                <CustomSelect
        className='input'
        onChange={value=>formik.setFieldValue('countryIso',value.value)}
        value={formik.values.countryIso}
        options={countryOptions}     
        />
      {formik.errors.countryIso ? <div className='error'>{formik.errors.countryIso}</div> : null}             
                            </div>
                        </div>
                   </div>
                   
                   <div class="row">
    	                    <div class="col-3">
        	          		    <div class="form-group">
        	          		        <label>{t('general.label.businessId')}</label>
            	                    <input type="text" class="form-control"  placeholder=""  {...formik.getFieldProps('businessId')} />
	            	            </div>
                   		    </div>
                   		    
                            <div class="col-3">
        	          		    <div class="form-group">
        	          		        <label>{t('general.label.taxId')}</label>
            	                    <input type="text" class="form-control"  placeholder=""  {...formik.getFieldProps('taxId')}/>
	            	            </div>
                   		    </div>

                   		    <div class="col-3">
        	          		    <div class="form-group">
        	          		        <label>{t('general.label.vatNo')}</label>
            	                    <input type="text" class="form-control"  placeholder=""  {...formik.getFieldProps('vatNo')} />
	            	            </div>
                   		    </div>
                   		 
                            <div class="col-3">
    		                    <div class="form-group">
            		                <label>{t('general.label.vatPayer')}</label>
                                    <CustomSelect
        className='input'
        onChange={value=>formik.setFieldValue('vatPayer',parseInt(value.value))}
        value={formik.values.vatPayer}
        options={yesNoOptions}     
        />
      {formik.errors.vatPayer ? <div className='error'>{formik.errors.vatPayer}</div> : null}

                   		        </div>
                   	        </div>
                    </div>

                    <div class="row">

                    	    <div class="col-12">
                   		        <div class="form-group">
                  			        <label>{t('general.label.description')}</label>
                    		        <input type="text" class="form-control" placeholder=""  {...formik.getFieldProps('description')} />
                  		        </div>
                  		    </div>
                   </div>

                   <div class="row">
                         	<div class="col-12">
                   		         <div class="form-group">
                  			        <label>{t('general.label.commercialRegister')}</label>
                    		        <input type="text" class="form-control" placeholder=""  {...formik.getFieldProps('commercialRegister')}/>
                  		        </div>
                  		    </div>
                   </div>
                   
                   <div class="row">
                     	    <div class="col-12">
                   		        <div class="form-group">
                  			        <label>{t('general.label.slogan')}</label>
                    		        <input type="text" class="form-control"  placeholder=""  {...formik.getFieldProps('slogan')}/>
                  		        </div>
                  		    </div>
                   </div>
              
                    <div class="card-footer">
                         <Button block type="submit">{t('general.button.save')}</Button>                                         
                    </div>
                </form>
        </div>
    );
};

const mapStateToProps = (state) => ({
    company: state.company.currentCompany
 });
 
 const mapDispatchToProps = (dispatch) => ({
     onCompanySave: (company) => dispatch({type: ActionTypes.SAVE_COMPANY, currentCompany: company})
 });
 
 export default connect(mapStateToProps, mapDispatchToProps)(BasicInformationsTab);
 